/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Channel_AgentInputs */

const vi_order_channel_agent = /** @type {(inputs: Order_Channel_AgentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đại lý`)
};

/**

* @param {Order_Channel_AgentInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_channel_agent = /** @type {((inputs?: Order_Channel_AgentInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Channel_AgentInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_channel_agent(inputs)
});